// extracted by mini-css-extract-plugin
module.exports = {"pageNavigation":"pagination_pageNavigation__z5MuF","activePage":"pagination_activePage__CWRw9","disabledPage":"pagination_disabledPage__70Re1"};